import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useNavigate } from "react-router-dom";

import expired from "data/icons/expired.svg";
import pending from "data/icons/pending.svg";
import checkGreen from "data/icons/check-green.svg";
import { Loading, CompanyItem } from "components/common";
import { IShortContract } from "store/contracts/contracts.types";
import { isFuture } from "services/data.service";
import grayDotIcon from "data/icons/dot-gray.svg";
import handshakeIcon from "data/icons/handshake.svg";
import exclamationIconOrange from "data/icons/exclamation-orange.svg";
import handshakeBlueIcon from "data/icons/handshake-blue.svg";
import "components/cases/CasesTable/CasesTable.scss";
import { RouteLinks } from "services/router.service";

import "./ContractorContractsTable.scss";

const statusIcons = {
  Active: checkGreen,
  Draft: pending,
  Pending: pending,
  Expired: expired,
};

interface IProps {
  contracts: any[];
}

const ContractorContractsTable = ({ contracts }: IProps) => {
  const navigate = useNavigate();

  const columns: ColumnsType<IShortContract> = [
    {
      title: "Status",
      dataIndex: "status_value",
      key: "status_value",
      width: 80,
      render: (value, item) => (
        <div style={ { display: "flex", gap: 20, alignItems: "center" } }>
          <Tooltip title={ item.warning_reason || value }>
            <img
              alt=""
              className={ `dot-prefix ${ item.warning_reason !== null && "warning" }` }
              src={
                item.warning_reason === null
                  ? !isFuture(item.date_end)
                    // @ts-ignore
                    ? statusIcons[ value ]
                    : grayDotIcon
                  : exclamationIconOrange }
            />
          </Tooltip>

          { item.handshake_completed ? (
            <Tooltip title="Handshaked">
              <img src={ handshakeBlueIcon } alt=""/>
            </Tooltip>
          ) : (
            <Tooltip title="Not handshaked">
              <img src={ handshakeIcon } alt=""/>
            </Tooltip>
          ) }
        </div>
      ),
    },
    {
      title: "Contract Number",
      dataIndex: "identifier",
      key: "identifier",
      className: "contract-number-table-cell",
      render: (value, item) =>
        <p
          className={ item.is_active ? "active" : "" }
          onClick={ () => handleOpenContract(item.id) }
        >
          { value }
        </p>,
      showSorterTooltip: false,
      width: 180,
    },
    {
      title: "Organisation",
      dataIndex: "customer",
      key: "customer",
      showSorterTooltip: false,
      className: `description-table-cell`,
      render: (value, item) => (
        <CompanyItem
          email={ item.contractor.default_email }
          has_account={ item.contractor.has_account }
          has_verified_account={ item.contractor.has_verified_account }
          official_name={ item.contractor.official_name }
          phone={ item.contractor.phone_number }
          value={ value }
        />
      ),
    },
    {
      title: "Alias",
      dataIndex: "alias",
      key: "alias",
      width: 350,
      showSorterTooltip: false,
    },
    {
      title: "Start date",
      dataIndex: "date_begin",
      key: "date_begin",
      showSorterTooltip: false,
      width: 140,
      onCell: () => ({
        style: { minWidth: "140px" },
      }),
    },
    {
      title: "End date",
      dataIndex: "date_end",
      key: "date_end",
      width: 140,
      render: (value, item) => <p className={ item.warning_reason === null ? "" : "warning" }>{ value }</p>,
      showSorterTooltip: false,
      onCell: () => ({
        style: { minWidth: "140px" },
      }),
    },
  ];

  const handleOpenContract = (contractId: number) => {
    navigate(RouteLinks.PROTECTED.CONTRACTS_ROUTES.CONTRACT + "/" + contractId);
  };

  return (
    <Loading
      isLoading={ false }
      isColored
      isFullWidth
      height={ 200 }
    >
      <Table
        className="cases-table contracts-table"
        columns={ columns }
        dataSource={ contracts }
        pagination={ false }
        tableLayout="auto"
        scroll={ { y: window.innerHeight - 183 - (document.getElementById("contracts-header-cell")?.offsetHeight || 0) } }
      />
    </Loading>
  )
}

export default ContractorContractsTable;
